import { Badge } from '@/components/ui/badge';
import { useTranslation } from 'react-i18next';
import { formatStartedAgo } from '@/lib/relativeTime';

export function ResultStatusBadge({
  status,
  startedAt,
}: {
  status: string;
  /** Story 081 — when status === 'in_progress' and this is set,
   *  the badge renders a native title tooltip with "Started X ago". */
  startedAt?: string | null;
}) {
  const { t } = useTranslation('director');
  if (status === 'confirmed') {
    return (
      <Badge variant="default" className="bg-green-600 text-xs">
        {t('rounds_page.result_status.confirmed')}
      </Badge>
    );
  }
  if (status === 'pending') {
    return (
      <Badge variant="secondary" className="text-xs text-amber-600">
        {t('rounds_page.result_status.pending')}
      </Badge>
    );
  }
  if (status === 'in_progress') {
    const tooltip = startedAt ? formatStartedAgo(startedAt) : undefined;
    return (
      <Badge
        variant="default"
        className="bg-blue-600 text-xs"
        title={tooltip}
      >
        {t('rounds_page.result_status.in_progress')}
      </Badge>
    );
  }
  if (status === 'none') {
    return (
      <Badge variant="outline" className="text-xs text-muted-foreground">
        {t('rounds_page.result_status.none')}
      </Badge>
    );
  }
  return null;
}
